// extracted by mini-css-extract-plugin
export default {"columnForm":"ColumnForm_columnForm__qddpL","columnFormTitle":"ColumnForm_columnFormTitle__tWa5D"};